import React, { FC, useEffect, useState } from "react";
import styled from "styled-components";
import ReactWordcloud from "react-wordcloud";

interface IWorldCloudProps {
  data: any;
}
const WordCloudGraph: FC<IWorldCloudProps> = (props: IWorldCloudProps) => {
  const { data } = props;
  const [keyWords, setKeyWords] = useState([]);

  useEffect(() => {
    if (props?.data !== undefined) {
      setKeyWords(data.map((item: any) => ({ text: item.keyword, value: item?.relevance ?? 0 })));
    }
  }, [props?.data]);

  const options = {
    colors: ["#F15C80", "#E4D354", "#7CB5EC", "#91E8E0", "#8084E9", "#2C908F", "#F7A35B", "#90ED7D", "#434348"],
    deterministic: false,
    fontFamily: "Roboto Slab",
    fontSizes: [10, 28],
    fontStyle: "normal",
    fontWeight: "bold",
    padding: 1,
    rotations: 0,
    rotationAngles: [0, 0],
    scale: "sqrt",
    spiral: "archimedean",
    transitionDuration: 1000,
    enableTooltip: false,
    title: {
      text: "Wordcloud of Lorem Ipsum",
    },
  };

  return (
    <Wrapper>
      <h4>KEYWORDS</h4>
      <div className="parent-container">
        <ReactWordcloud options={options} words={keyWords} />
      </div>
      {/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
    </Wrapper>
  );
};

export default React.memo(WordCloudGraph);

const Wrapper = styled.div`
  background: white;
  width: 100%;
  height: 400px;
  position: relative;
  border-radius: 10px !important;
  box-shadow: 0px 0px 17px -2px rgb(0 0 0 / 8%);

  .parent-container {
    height: 400px;
    div {
      padding: 87px 24px 67px 24px;
    }
  }
  h4 {
    font-family: "Roboto Slab";
    font-weight: bold;
    font-size: 28px;
    position: absolute;
    top: 24px;
    left: 24px;
  }
`;
